<template>
  <div class="pagination">
    <div class="rows-per-page">
      Rows per page
      <b-form-select v-model="currentPageSize" @change="onPageSizeChange">
        <b-form-select-option
          v-for="option in pageSizeOptions"
          :key="option"
          :value="option"
        >
          {{ option }}
        </b-form-select-option>
      </b-form-select>
    </div>

    <div class="records-range">
      {{ currentPage > 1 ? pageSize * (currentPage - 1) + 1 : 1 }}-{{
        totalRecords > pageSize * currentPage
          ? pageSize * currentPage
          : totalRecords
      }}
      of {{ totalRecords }}
    </div>

    <div class="navigation-buttons">
      <button class="first nav-button" @click="firstPage">
        <NavFirstIcon />
      </button>

      <button class="prev nav-button" @click="prevPage">
        <NavPrevIcon />
      </button>

      <button class="next nav-button" @click="nextPage">
        <NavNextIcon />
      </button>

      <button class="last nav-button" @click="lastPage">
        <NavLastIcon />
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import NavFirstIcon from '@/Icons/NavFirstIcon.vue'
import NavLastIcon from '@/Icons/NavLastIcon.vue'
import NavNextIcon from '@/Icons/NavNextIcon.vue'
import NavPrevIcon from '@/Icons/NavPrevIcon.vue'
import Vue from 'vue'

export default Vue.extend({
  name: 'DataTablePagination',
  components: {
    NavFirstIcon,
    NavLastIcon,
    NavNextIcon,
    NavPrevIcon
  },
  props: {
    pageSizeOptions: {
      type: Array,
      default: () => [10, 20, 50]
    },
    currentPage: {
      type: Number,
      default: 1
    },
    totalRecords: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    onPageChange: {
      type: Function,
      required: true
    },
    onPageSizeChange: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      currentPageSize: this.pageSize
    }
  },
  methods: {
    firstPage() {
      const newPage = 1
      this.onPageChange(newPage)

      return 1
    },
    prevPage() {
      const newPage = this.currentPage > 1 ? this.currentPage - 1 : 1
      this.onPageChange(newPage)

      return newPage
    },
    nextPage() {
      const lastPage = Math.ceil(this.totalRecords / this.pageSize)
      const newPage =
        this.currentPage < lastPage ? this.currentPage + 1 : lastPage
      this.onPageChange(newPage)

      return newPage
    },
    lastPage() {
      const newPage = Math.ceil(this.totalRecords / this.pageSize)
      this.onPageChange(newPage)

      return newPage
    }
  }
})
</script>

<style lang="scss" scoped>
.pagination {
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: flex-end;
  padding: 12px;
}

.rows-per-page {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  width: fit-content;

  white-space: nowrap;
}
.nav-button {
  background: none;
  border: 0;
}
</style>
